module.exports = app_owpp_offerSelection;